import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const RpmEnrollmentCompleteModal = ({ show, onHide, workItemText }) => (
    <Modal show={show} onHide={onHide}>
        <Modal.Header closeButton onHide={onHide}>
            <Modal.Title>
                <div className="text-align-center">Enrollment Complete</div>
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <div style={{ textAlign: 'center', padding: '10px 0 20px' }}>
                <div style={{
                    width: 64,
                    height: 64,
                    borderRadius: '50%',
                    background: '#5cb85c',
                    color: '#fff',
                    fontSize: 32,
                    lineHeight: '64px',
                    margin: '0 auto 16px',
                }}>
                    &#10003;
                </div>
                <div style={{ fontWeight: 600, fontSize: 18, color: '#337ab7', marginBottom: 16 }}>
                    RPM Add-On enrollment complete
                </div>
                <div style={{
                    textAlign: 'left',
                    background: '#f5f5f5',
                    border: '1px solid #ddd',
                    borderRadius: 4,
                    padding: 16,
                }}>
                    <div style={{ fontWeight: 600, color: '#337ab7', marginBottom: 8 }}>
                        Chart work-item recorded
                    </div>
                    <div style={{ fontSize: 14, color: '#333' }}>
                        {workItemText}
                    </div>
                </div>
            </div>
        </Modal.Body>
        <Modal.Footer>
            <Button onClick={onHide} style={{ float: 'left' }}>Close</Button>
            <Button bsStyle="primary" onClick={onHide}>Done</Button>
        </Modal.Footer>
    </Modal>
);

export default RpmEnrollmentCompleteModal;
